<template>
    <footer class="footer">
        <div class="page-inner">
            <div class="top">
                <div class="switch">
                    <span @click="switchBlackWhite()">
                        <svg
                            id="is-black"
                            viewBox="0 0 91.38 32.17"
                            v-if="is_black"
                        >
                            <path
                                d="M91,13.63A16,16,0,0,0,79.61,8.92H20.38a16.08,16.08,0,0,0,0,32.16H79.6A16.08,16.08,0,0,0,91,13.63ZM89.55,35a14,14,0,0,1-10,4.12H20.36a14.08,14.08,0,0,1,0-28.16H79.61a14.07,14.07,0,0,1,9.94,24Zm-9-18.39v2.92H78.7V16.57Zm5.2,2.54-1.89,2.25L82.44,20.2,84.32,18ZM88,24.4l-2.88.52-.32-1.78,2.89-.51Zm-.71,4L86.43,30,83.9,28.5l.9-1.56Zm-4,4.17-1.69.62-1-2.75,1.69-.61Zm-4.75-2.13-1,2.75-1.69-.62,1-2.74ZM75.3,28.5,72.76,30l-.9-1.56,2.54-1.46Zm-1-5.36L74,24.92l-2.88-.52.31-1.77Zm2.41-2.94-1.38,1.16L73.5,19.11,74.88,18ZM61,21.35v1h2.33v6.61h1.12V22.31h2.32v-1Zm-2.49,0v3.08H54.66V21.35H53.54v7.57h1.12V25.4h3.86v3.52h1.13V21.35ZM48,24.79v1h2.54a2.21,2.21,0,0,1-2.07,2.35c-.1,0-.2,0-.3,0-1.56,0-2.58-1.18-2.58-3s1.06-3,2.59-3a2.22,2.22,0,0,1,2.22,1.62l1.16-.34a3.4,3.4,0,0,0-3.37-2.21,3.63,3.63,0,0,0-3.75,3.52,2.54,2.54,0,0,0,0,.39A3.58,3.58,0,0,0,47.72,29,1.67,1.67,0,0,0,48,29a2.77,2.77,0,0,0,2.53-1.25h0v1.13h1.05V24.79Zm-6.35-3.44v7.57h1.12V21.35Zm-5.19,6.59V21.35H35.34v7.57h4.95v-1Zm-6.37-3a9.72,9.72,0,1,1-9.72-9.7A9.72,9.72,0,0,1,30.09,25ZM79.6,21.14A3.86,3.86,0,1,0,83.46,25,3.86,3.86,0,0,0,79.6,21.14Zm0,5.91A2.06,2.06,0,1,1,81.66,25,2.05,2.05,0,0,1,79.6,27.05Z"
                                transform="translate(-4.31 -8.92)"
                            />
                        </svg>
                        <svg viewBox="0 0 91.38 32.18" v-else id="is-white">
                            <path
                                d="M91,13.63A16,16,0,0,0,79.61,8.91H20.38a16.09,16.09,0,0,0,0,32.18H79.6A16.09,16.09,0,0,0,91,13.63ZM89.56,35a14,14,0,0,1-10,4.12H20.36a14.09,14.09,0,0,1,0-28.18H79.61A14.09,14.09,0,0,1,89.56,35ZM39,28.91c2.28,0,3.6-1.51,3.6-3.8s-1.3-3.77-3.67-3.77H36.17v7.57Zm-1.7-1V22.31h1.46c1.85,0,2.69,1,2.69,2.8,0,1.64-.74,2.83-2.46,2.83Zm13.25,1L47.6,21.35H46.2l-3,7.56H44.4l.74-2h3.51l.75,2ZM48.29,26H45.5l1.4-3.69Zm9.43,2.93L55.51,25.6a2,2,0,0,0,1.75-2.1c0-1.44-1-2.15-2.45-2.15H51.88v7.56H53V25.68h1.3l2.11,3.23Zm-2.9-6.6c.89,0,1.33.47,1.33,1.21s-.5,1.2-1.39,1.2H53V22.31Zm6.81,2.45,3.45-3.41H63.64l-3.38,3.46V21.35H59.14v7.56h1.12v-4l3.86,4h1.49Zm18-9.48A9.72,9.72,0,1,1,69.88,25,9.72,9.72,0,0,1,79.6,15.28Zm-49.29,10A9.37,9.37,0,0,1,29.69,28a9.12,9.12,0,0,1-3.47,4.31A9.3,9.3,0,0,1,21,33.91a9.32,9.32,0,0,1-5.77-2A1,1,0,0,1,15,30.75a1,1,0,0,1,1-.64,7.3,7.3,0,0,0,5.11-12.95,1,1,0,0,1,.7-1.78A9.28,9.28,0,0,1,30.31,25.31Z"
                                transform="translate(-4.31 -8.91)"
                            />
                        </svg>
                    </span>
                </div>

                <div
                    class="back-top"
                    @click="backTop"
                    :class="{ 'is-show': show_ico }"
                >
                    <svg viewBox="0 0 63 63" id="to-top">
                        <g transform="translate(-1170 -4365)">
                            <g transform="translate(1170 4365)">
                                <path
                                    d="M 31.49999809265137 3.999996185302734 C 27.78576278686523 3.999996185302734 24.18474960327148 4.726539611816406 20.7969856262207 6.159446716308594 C 17.52278518676758 7.544315338134766 14.5814094543457 9.527717590332031 12.05456161499023 12.05456161499023 C 9.527717590332031 14.5814094543457 7.544315338134766 17.52278518676758 6.159446716308594 20.7969856262207 C 4.726539611816406 24.18474960327148 3.999996185302734 27.78576278686523 3.999996185302734 31.49999809265137 C 3.999996185302734 35.2142333984375 4.726539611816406 38.81524658203125 6.159446716308594 42.20301055908203 C 7.544315338134766 45.47721099853516 9.527717590332031 48.41858673095703 12.05456161499023 50.9454345703125 C 14.5814094543457 53.47228240966797 17.52278518676758 55.45568084716797 20.7969856262207 56.84054946899414 C 24.18474960327148 58.27345657348633 27.78576278686523 59 31.49999809265137 59 C 35.2142333984375 59 38.81524658203125 58.27345657348633 42.20301055908203 56.84054946899414 C 45.47721099853516 55.45568084716797 48.41858673095703 53.47228240966797 50.9454345703125 50.9454345703125 C 53.47228240966797 48.41858673095703 55.45568084716797 45.47721099853516 56.84054946899414 42.20301055908203 C 58.27345657348633 38.81524658203125 59 35.2142333984375 59 31.49999809265137 C 59 27.78576278686523 58.27345657348633 24.18474960327148 56.84054946899414 20.7969856262207 C 55.45568084716797 17.52278518676758 53.47228240966797 14.5814094543457 50.9454345703125 12.05456161499023 C 48.41858673095703 9.527717590332031 45.47721099853516 7.544315338134766 42.20301055908203 6.159446716308594 C 38.81524658203125 4.726539611816406 35.2142333984375 3.999996185302734 31.49999809265137 3.999996185302734 M 31.49999809265137 -3.814697265625e-06 C 48.89696502685547 -3.814697265625e-06 63 14.10303497314453 63 31.49999809265137 C 63 48.89696502685547 48.89696502685547 63 31.49999809265137 63 C 14.10303497314453 63 -3.814697265625e-06 48.89696502685547 -3.814697265625e-06 31.49999809265137 C -3.814697265625e-06 14.10303497314453 14.10303497314453 -3.814697265625e-06 31.49999809265137 -3.814697265625e-06 Z"
                                />
                            </g>
                            <path
                                d="M10.223,46.995V20.764L21.44,31.472V24.843L7.5,11.53-6.49,24.9v6.572L4.727,20.764v26.23Z"
                                transform="translate(1194.49 4366.47)"
                            />
                        </g>
                    </svg>
                </div>
            </div>

            <div class="bottom">
                <ul>
                    <li
                        v-for="(item, index) in $store.state.footer.links"
                        :key="index"
                    >
                        <Link
                            v-if="item.link"
                            :post_link="item.link"
                            v-html="item.text"
                            :id="`${item.text}-footer`"
                        />
                    </li>
                </ul>
            </div>

            <nav class="menus" v-if="menus.length !== 0">
                <ul>
                    <li
                        v-for="item in menus"
                        :key="item.ID"
                        class="menu-item"
                        :class="['menu-' + item.object_slug]"
                    >
                        <span
                            v-if="item.url === '#onlytext'"
                            v-html="item.title"
                        ></span>
                        <Link v-else :link="item" v-html="item.title"></Link>
                    </li>
                </ul>
            </nav>
        </div>
    </footer>
</template>

<script>
// import '@/assets/svg/logo.svg?sprite';
// import '@/assets/svg/instagram.svg?sprite';
// import '@/assets/svg/facebook.svg?sprite';
// import '@/assets/svg/twitter.svg?sprite';

import Link from "@/components/ui/Link.vue";

export default {
    name: "site-footer",

    data() {
        return {
            is_black: false,
            show_ico: false,
            menus: []
        };
    },

    components: {
        Link
    },

    methods: {
        switchBlackWhite() {
            this.is_black = !this.is_black;
            document.documentElement.classList.toggle("black-mode");
        },

        backTop() {
            this.$smoothScroll({
                scrollTo: window.document.body,
                duration: 500
            });
        },

        handleScroll() {
            if (window.innerWidth < 767) {
                this.show_ico =
                    Math.max(
                        0,
                        document.documentElement.scrollTop ||
                            window.pageYOffset ||
                            0
                    ) > 400;
            }
        }
    },

    mounted() {
        if (window.innerWidth < 780) {
            this.$ajax.get("/menus/6").then(res => {
                this.menus = res.data.items;
            });
        }
    },

    created() {
        window.addEventListener("scroll", this.handleScroll);
    },

    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    }
};
</script>
<style lang="scss">
.footer {
    .top {
        padding: var(--padding);
        display: flex;
        align-items: center;

        .switch {
            flex: 1;

            span {
                cursor: pointer;
                display: block;
            }

            svg {
                height: 4rem;
                width: 11rem;
            }
        }

        .back-top {
            cursor: pointer;

            svg {
                height: 4.7rem;
                width: 4.7rem;
                transform: scale(1);
                transition: all 0.2s;
            }

            &:hover {
                transform: scale(0.9);
                transition: all 0.2s;
            }
        }
    }

    .menus {
        display: none;
    }
}

@media only screen and (max-width: 767px) {
    .footer {
        .top {
            padding: var(--padding) 0;

            .switch {
                svg {
                    height: 10rem;
                    width: 26rem;
                }
            }

            .back-top {
                svg {
                    height: 10rem;
                    width: 10rem;
                }
            }
        }

        .menus {
            padding: 0 0 var(--padding) 0;
            display: flex;
            box-sizing: border-box;
            width: 100%;

            ul {
                display: flex;
                font-size: var(--small-size);
                flex: 1;

                li {
                    padding-right: var(--padding);

                    a:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>
